/**
 * Generated from PuzzleScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function PuzzleScreenLayout(this: $PuzzleScreenLayout) {
	$(this, "main", main, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	const puzzlePieces = this.puzzlePieces;
	$(puzzlePieces, 0, puzzlePieces1, {x:-769.2, y:-627.45, sx:0.970, sy:0.970});
	$(puzzlePieces, 1, puzzlePieces2, {x:-380.4, y:-627.2, sx:0.970, sy:0.970});
	$(puzzlePieces, 2, puzzlePieces3, {x:17.45, y:-627.65, sx:0.970, sy:0.970});
	$(puzzlePieces, 3, puzzlePieces4, {x:-769.5, y:-322.95, sx:0.970, sy:0.970});
	$(puzzlePieces, 4, puzzlePieces5, {x:-375.15, y:-320.8, sx:0.970, sy:0.970});
	$(puzzlePieces, 5, puzzlePieces6, {x:-61.95, y:-396, sx:0.970, sy:0.970});
	$(puzzlePieces, 6, puzzlePieces7, {x:-769.2, y:-1.25, sx:0.970, sy:0.970});
	$(puzzlePieces, 7, puzzlePieces8, {x:-383.4, y:-3.8, sx:0.970, sy:0.970});
	$(puzzlePieces, 8, puzzlePieces9, {x:5.9, y:-6.45, sx:0.970, sy:0.970});
	const puzzleRandomPoints = this.puzzleRandomPoints;
	$(puzzleRandomPoints, 0, puzzlePiece3d1, {x:601.45, y:-727.45, w:387.74, h: 325.49});
	$(puzzleRandomPoints, 1, puzzlePiece3d1, {x:618.95, y:-370.55, w:387.74, h: 325.49});
	$(puzzleRandomPoints, 2, puzzlePiece3d1, {x:622.45, y:-3.55, w:387.74, h: 325.49});
	$(puzzleRandomPoints, 3, puzzlePiece3d1, {x:630.55, y:359.5, w:387.74, h: 325.49});
	$(puzzleRandomPoints, 4, puzzlePiece3d1, {x:-1000.85, y:426.5, w:387.74, h: 325.49});
	$(puzzleRandomPoints, 5, puzzlePiece3d1, {x:-587.1, y:435.5, w:387.74, h: 325.49});
	$(puzzleRandomPoints, 6, puzzlePiece3d1, {x:-176.45, y:438, w:387.74, h: 325.49});
	$(puzzleRandomPoints, 7, puzzlePiece3d1, {x:228.8, y:432, w:387.74, h: 325.49});
	$(this, "background", background, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "puzzleBox", puzzleBox, {x:-201.05, y:-108.45, w:1545.00, h: 1229.00});
	$(this, "puzzleContainer", puzzleContainer, {x:-769.2, y:-627.45, w:1208.58, h: 961.24});
	$(this, "photo", photo, {x:-166.8, y:-147.25, sx:0.970, sy:0.970});
	$(this, "photoScaleUp", puzzleSpain2x, {x:0, y:0, w:1559.98, h: 1243.72});
	return this;
}
function background(this: $background) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-puzzle.jpg", 0.000, 0.000);
	return this;
}
function puzzleBox(this: $puzzleBox) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-box.png", 0.500, 0.500);
	return this;
}
function puzzleContainer(this: $puzzleContainer) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-container.png", 0.000, 0.000);
	return this;
}
function puzzlePieces1(this: $puzzlePieces1) {
	$(this, "background", puzzlePiece3d1, {x:0, y:0, w:517.00, h: 434.00});
	$(this, "foreground", puzzlePieceSpain1, {x:0, y:0, w:504.00, h: 422.00});
	return this;
}
function puzzlePiece3d1(this: $puzzlePiece3d1) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-1.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain1(this: $puzzlePieceSpain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-1.png", 0.000, 0.000);
	return this;
}
function puzzlePieces2(this: $puzzlePieces2) {
	$(this, "background", puzzlePiece3d2, {x:0, y:0, w:536.00, h: 425.00});
	$(this, "foreground", puzzlePieceSpain2, {x:0, y:0, w:526.00, h: 414.00});
	return this;
}
function puzzlePiece3d2(this: $puzzlePiece3d2) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-2.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain2(this: $puzzlePieceSpain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-2.png", 0.000, 0.000);
	return this;
}
function puzzlePieces3(this: $puzzlePieces3) {
	$(this, "background", puzzlePiece3d3, {x:0, y:0, w:433.00, h: 353.00});
	$(this, "foreground", puzzlePieceSpain3, {x:0, y:0, w:422.00, h: 341.00});
	return this;
}
function puzzlePiece3d3(this: $puzzlePiece3d3) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-3.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain3(this: $puzzlePieceSpain3) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-3.png", 0.000, 0.000);
	return this;
}
function puzzlePieces4(this: $puzzlePieces4) {
	$(this, "background", puzzlePiece3d4, {x:0, y:0, w:527.00, h: 452.00});
	$(this, "foreground", puzzlePieceSpain4, {x:0, y:0, w:517.00, h: 440.00});
	return this;
}
function puzzlePiece3d4(this: $puzzlePiece3d4) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-4.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain4(this: $puzzlePieceSpain4) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-4.png", 0.000, 0.000);
	return this;
}
function puzzlePieces5(this: $puzzlePieces5) {
	$(this, "background", puzzlePiece3d5, {x:0, y:0, w:435.00, h: 446.00});
	$(this, "foreground", puzzlePieceSpain5, {x:0, y:0, w:424.00, h: 436.00});
	return this;
}
function puzzlePiece3d5(this: $puzzlePiece3d5) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-5.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain5(this: $puzzlePieceSpain5) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-5.png", 0.000, 0.000);
	return this;
}
function puzzlePieces6(this: $puzzlePieces6) {
	$(this, "background", puzzlePiece3d6, {x:0, y:0, w:514.00, h: 523.00});
	$(this, "foreground", puzzlePieceSpain6, {x:0, y:0, w:505.00, h: 514.00});
	return this;
}
function puzzlePiece3d6(this: $puzzlePiece3d6) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-6.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain6(this: $puzzlePieceSpain6) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-6.png", 0.000, 0.000);
	return this;
}
function puzzlePieces7(this: $puzzlePieces7) {
	$(this, "background", puzzlePiece3d7, {x:0, y:0, w:520.00, h: 345.00});
	$(this, "foreground", puzzlePieceSpain7, {x:0, y:0, w:507.00, h: 335.00});
	return this;
}
function puzzlePiece3d7(this: $puzzlePiece3d7) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-7.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain7(this: $puzzlePieceSpain7) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-7.png", 0.000, 0.000);
	return this;
}
function puzzlePieces8(this: $puzzlePieces8) {
	$(this, "background", puzzlePiece3d8, {x:0, y:0, w:513.00, h: 348.00});
	$(this, "foreground", puzzlePieceSpain8, {x:0, y:0, w:501.00, h: 338.00});
	return this;
}
function puzzlePiece3d8(this: $puzzlePiece3d8) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-8.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain8(this: $puzzlePieceSpain8) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-8.png", 0.000, 0.000);
	return this;
}
function puzzlePieces9(this: $puzzlePieces9) {
	$(this, "background", puzzlePiece3d9, {x:0, y:0, w:444.00, h: 351.00});
	$(this, "foreground", puzzlePieceSpain9, {x:0, y:0, w:435.00, h: 341.00});
	return this;
}
function puzzlePiece3d9(this: $puzzlePiece3d9) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-3d-9.png", 0.000, 0.000);
	return this;
}
function puzzlePieceSpain9(this: $puzzlePieceSpain9) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-piece-spain-9.png", 0.000, 0.000);
	return this;
}
export function photo(this: $photo) {
	const frames = this.frames;
	$(frames, 0, puzzleFrame12x, {x:0, y:0, w:1392.10, h: 1122.33});
	$(frames, 1, puzzleFrame22x, {x:0, y:0, w:1391.16, h: 1122.33});
	$(frames, 2, puzzleFrame32x, {x:0, y:0, w:1392.10, h: 1122.33});
	$(frames, 3, puzzleFrame42x, {x:0, y:0, w:1391.11, h: 1122.29});
	$(frames, 4, puzzleFrame52x, {x:0, y:0, w:1394.87, h: 1123.23});
	$(this, "image", puzzleSpain2x, {x:0, y:0, w:1248.00, h: 995.00});
	return this;
}
function puzzleSpain2x(this: $puzzleSpain2x) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-china@2x.png", 0.500, 0.501);
	return this;
}
function puzzleFrame12x(this: $puzzleFrame12x) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-frame-1@2x.png", 0.500, 0.500);
	return this;
}
function puzzleFrame22x(this: $puzzleFrame22x) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-frame-2@2x.png", 0.500, 0.500);
	return this;
}
function puzzleFrame32x(this: $puzzleFrame32x) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-frame-3@2x.png", 0.500, 0.500);
	return this;
}
function puzzleFrame42x(this: $puzzleFrame42x) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-frame-4@2x.png", 0.500, 0.500);
	return this;
}
function puzzleFrame52x(this: $puzzleFrame52x) {
	if (this.setLayoutTexture) this.setLayoutTexture("puzzle-frame-5@2x.png", 0.500, 0.500);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $PuzzleScreenLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly puzzlePieces: $$array<$puzzlePieces1|$puzzlePieces2|$puzzlePieces3|$puzzlePieces4|$puzzlePieces5|$puzzlePieces6|$puzzlePieces7|$puzzlePieces8|$puzzlePieces9>;
	readonly puzzleRandomPoints: $$array<$puzzlePiece3d1>;
	readonly background: $background;
	readonly puzzleBox: $puzzleBox;
	readonly puzzleContainer: $puzzleContainer;
	readonly photo: $photo;
	readonly photoScaleUp: $puzzleSpain2x;
}
interface $background extends $$sprite {
}
interface $puzzleBox extends $$sprite {
}
interface $puzzleContainer extends $$sprite {
}
interface $puzzlePieces1 extends $$container {
	readonly background: $puzzlePiece3d1;
	readonly foreground: $puzzlePieceSpain1;
}
interface $puzzlePiece3d1 extends $$sprite {
}
interface $puzzlePieceSpain1 extends $$sprite {
}
interface $puzzlePieces2 extends $$container {
	readonly background: $puzzlePiece3d2;
	readonly foreground: $puzzlePieceSpain2;
}
interface $puzzlePiece3d2 extends $$sprite {
}
interface $puzzlePieceSpain2 extends $$sprite {
}
interface $puzzlePieces3 extends $$container {
	readonly background: $puzzlePiece3d3;
	readonly foreground: $puzzlePieceSpain3;
}
interface $puzzlePiece3d3 extends $$sprite {
}
interface $puzzlePieceSpain3 extends $$sprite {
}
interface $puzzlePieces4 extends $$container {
	readonly background: $puzzlePiece3d4;
	readonly foreground: $puzzlePieceSpain4;
}
interface $puzzlePiece3d4 extends $$sprite {
}
interface $puzzlePieceSpain4 extends $$sprite {
}
interface $puzzlePieces5 extends $$container {
	readonly background: $puzzlePiece3d5;
	readonly foreground: $puzzlePieceSpain5;
}
interface $puzzlePiece3d5 extends $$sprite {
}
interface $puzzlePieceSpain5 extends $$sprite {
}
interface $puzzlePieces6 extends $$container {
	readonly background: $puzzlePiece3d6;
	readonly foreground: $puzzlePieceSpain6;
}
interface $puzzlePiece3d6 extends $$sprite {
}
interface $puzzlePieceSpain6 extends $$sprite {
}
interface $puzzlePieces7 extends $$container {
	readonly background: $puzzlePiece3d7;
	readonly foreground: $puzzlePieceSpain7;
}
interface $puzzlePiece3d7 extends $$sprite {
}
interface $puzzlePieceSpain7 extends $$sprite {
}
interface $puzzlePieces8 extends $$container {
	readonly background: $puzzlePiece3d8;
	readonly foreground: $puzzlePieceSpain8;
}
interface $puzzlePiece3d8 extends $$sprite {
}
interface $puzzlePieceSpain8 extends $$sprite {
}
interface $puzzlePieces9 extends $$container {
	readonly background: $puzzlePiece3d9;
	readonly foreground: $puzzlePieceSpain9;
}
interface $puzzlePiece3d9 extends $$sprite {
}
interface $puzzlePieceSpain9 extends $$sprite {
}
interface $photo extends $$container {
	readonly frames: $$array<$puzzleFrame12x|$puzzleFrame22x|$puzzleFrame32x|$puzzleFrame42x|$puzzleFrame52x>;
	readonly image: $puzzleSpain2x;
}
interface $puzzleSpain2x extends $$sprite {
}
interface $puzzleFrame12x extends $$sprite {
}
interface $puzzleFrame22x extends $$sprite {
}
interface $puzzleFrame32x extends $$sprite {
}
interface $puzzleFrame42x extends $$sprite {
}
interface $puzzleFrame52x extends $$sprite {
}
